// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-report-death-details-v2/form-item-report-death-details-v2.component.scss
// module id = 976
// module chunks = 0